import { appVersionState } from '@/recoil/atom';
import { useAtom } from 'jotai';
import { t } from 'i18next';

const AppVersionInfo = () => {
  const [versionState, setVersionState] = useAtom(appVersionState);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', fontSize: '14px', lineHeight: '20px' }}>
          <div>{t('버전')}</div>
          <div style={{ fontWeight: '500', marginLeft: '12px' }}>
            {`v${versionState?.currentVersion}${
              versionState.isTestFlight ? '(TestFlight)' : ''
            }`}
          </div>
        </div>
        <div
          style={{
            fontSize: '14px',
            color: versionState?.isNeeded
              ? 'var(--dk-danger, #F55060)'
              : 'var(--dk-text-secondary, #888D96)',
          }}
        >
          {versionState?.isNeeded
            ? t('업데이트 가능한 최신 버전이 있습니다.')
            : t('최신 버전 사용중')}
        </div>
      </div>
      {versionState?.isNeeded && (
        <a
          style={{
            width: '100%',
            display: 'flex',
            marginTop: '16px',
            borderRadius: '6px',
            border: '1px solid var(--dk-line, #E7E9EC)',
            padding: '14px',
            color: 'var(--dk-text, black)',
            backgroundColor: 'var(--dk-bg, white)',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          href={versionState?.storeUrl}
          target={'_blank'}
          rel={'noreferrer'}
        >
          {t('업데이트')}
        </a>
      )}
    </div>
  );
};
export default AppVersionInfo;
